import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { RiseAgentService } from "@/_services/rise-agent.service";
import { TerminologyService } from "@/_services/terminology/terminology.service";
import { TermKey } from "@/_services/terminology/catalog";

/**
 * Preset questions on the dashboard that open the agent already answering.
 *
 * The agent can already query hazards, audits, actions, reports, evaluations
 * and objectives; what it lacked was a way in from the page people land on.
 * A click asks the question rather than opening an empty chat box the person
 * then has to think of something for.
 */
@Component({
    selector: "app-ask-rise",
    standalone: true,
    imports: [CommonModule, SharedComponentsModule],
    templateUrl: "./ask-rise.component.html",
    styleUrl: "./ask-rise.component.scss",
})
export class AskRiseComponent implements OnInit {
    /**
     * A member gets one prompt rather than three. The other two ask about the
     * account, which is not theirs to see, and a single prompt about their own
     * work keeps the entry point without implying access they do not have.
     */
    @Input() scope: "account" | "mine" = "account";

    title = "";
    prompts: string[] = [];

    constructor(
        private riseAgentService: RiseAgentService,
        private terminology: TerminologyService,
    ) {}

    ngOnInit(): void {
        this.title = this.term("dashboard.ask.title");
        this.prompts =
            this.scope === "mine"
                ? [this.term("dashboard.ask.prompt.mine")]
                : [
                      this.term("dashboard.ask.prompt.attention"),
                      this.term("dashboard.ask.prompt.overdue"),
                      this.term("dashboard.ask.prompt.trend"),
                  ];
    }

    ask(prompt: string): void {
        this.riseAgentService.ask(prompt);
    }

    private term(key: string): string {
        return this.terminology.resolve(key as TermKey);
    }
}
